import { Navigation } from "./navigation";
import { Header } from "./header";
import { About } from "./about";
import { Testimonials } from "./testimonials";
import { Team } from "./Team";
import { Contact } from "./contact";
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Contenido = (props) => {
  return (
    <div>
      <Navigation />
      <Header data={props.info["Header"]} />
      <About data={props.info["About"]} />
      <Team data={props.info["Team"]} categorias={props.categorias} />
      <Testimonials data={props.info["Testimonials"]} />
      <Contact data={props.info["Contact"]} />
    </div>
  );
};

export default Contenido;
